import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import IcomoonReact from 'icomoon-react';
import { useTheme } from 'emotion-theming';

import iconSet from '../../../../shared/images/teambuildr-selection.json';

/* 6px + 16px + 6px padding and line height give a 28px pill, so it lines up
   with the "+ Add" trigger beside it. */
const Pill = styled('span')`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  max-width: 100%;
  padding: 6px 8px 6px 12px;
  border-radius: 14px;
  background: ${({ theme }) => theme.colors.buttonPrimaryBg};
  font-family: 'Nunito Sans';
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.white};
`;

const PillLabel = styled('span')`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const RemoveButton = styled('button')`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: transparent;
  cursor: pointer;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
  &:focus {
    outline: none;
  }
  &:focus-visible {
    box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.hover};
  }
`;

const CopyTargetPill = ({
  targetId, label, onRemove, removeButtonRef,
}) => {
  const { colors } = useTheme();

  const handleRemoveClick = () => {
    onRemove(targetId);
  };

  return (
    <Pill>
      <PillLabel title={label}>{label}</PillLabel>
      <RemoveButton
        aria-label={`Remove ${label}`}
        onClick={handleRemoveClick}
        ref={removeButtonRef}
        type='button'
      >
        <IcomoonReact aria-hidden='true' color={colors.white} icon='remove' iconSet={iconSet} size={8} />
      </RemoveButton>
    </Pill>
  );
};

CopyTargetPill.propTypes = {
  targetId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: PropTypes.string.isRequired,
  onRemove: PropTypes.func.isRequired,
  removeButtonRef: PropTypes.func,
};

CopyTargetPill.defaultProps = {
  removeButtonRef: undefined,
};

export default CopyTargetPill;
